import HWIcon from './HWIcon'

export default HWIcon
